import {extractErrorId, generateErrorId} from './errorId';

export const ERROR_RETURN_URL_KEY = 'system_error_return_url';

const SYSTEM_ERROR_STATUSES = new Set([500, 502, 503, 504]);

export function redirectToSystemError(status: number, error?: unknown) {
    if (typeof window === 'undefined') {
        return;
    }

    if (window.location.pathname === '/error') {
        return;
    }

    const errorId = extractErrorId(error) || generateErrorId();
    const params = new URLSearchParams({
        code: String(status),
        id: errorId
    });

    sessionStorage.setItem(ERROR_RETURN_URL_KEY, window.location.pathname + window.location.search);
    window.location.assign(`/error?${params.toString()}`);
}

export function isSystemErrorStatus(status?: number): status is number {
    return typeof status === 'number' && SYSTEM_ERROR_STATUSES.has(status);
}
